//
//
//
//
//
//
//
//
import List from './List.vue';
export default {
  components: {
    List: List
  },
  data: function data() {
    return {
      isShowList: true
    };
  }
};